import React from 'react';
import { Star } from 'lucide-react';
import { Section } from './Shared';
export interface TestimonialProps {
  initials: string;
  name: string;
  location: string;
  text: string;
  product?: string;
}
export const TestimonialCard = ({
  initials,
  name,
  location,
  text,
  product
}: TestimonialProps) => <div className="glass-panel p-6 md:p-8 rounded-2xl flex flex-col h-full pl-[15px] pr-[15px] pt-[1px] pb-[1px]" data-id="element-273">
    <div className="flex items-center mb-4" data-id="element-274">
      <div className="w-9 h-9 md:w-12 md:h-12 rounded-full bg-brand-surfaceLight flex items-center justify-center text-brand-gold font-serif font-bold text-sm md:text-xl border border-brand-pink/30 mr-3 md:mr-4 shrink-0" data-id="element-275">
        {initials}
      </div>
      <div data-id="element-276">
        <div className="flex text-brand-gold mb-1 text-[15px]" data-id="element-277">
          {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" data-id="element-278" />)}
        </div>
        <div className="font-medium text-brand-text" data-id="element-279">{name}</div>
        <div className="text-xs text-brand-muted" data-id="element-280">
          {location} {product && `— ${product}`}
        </div>
      </div>
    </div>
    <p className="text-brand-text/90 italic flex-grow text-[13px]" data-id="element-281">"{text}"</p>
  </div>;
export const InitialTestimonials = () => {
  const testimonials = [{
    initials: 'MG',
    name: 'Marcela G.',
    location: 'Córdoba',
    text: 'Empecé el Tomo 1 un lunes. El viernes ya había pagado una deuda que tenía hacía 8 meses. Algo cambió en mi cabeza.'
  }, {
    initials: 'LP',
    name: 'Laura P.',
    location: 'Rosario',
    text: 'Los decretos me parecían cosa de libros rosados hasta que empecé a registrar mis sincronías. En 30 días llegaron 3 clientes nuevos sin buscarlos.'
  }, {
    initials: 'RM',
    name: 'Roberto M.',
    location: 'Buenos Aires',
    text: 'Por primera vez en años sé exactamente adónde va cada peso.'
  }];
  return <Section className="pt-8 pb-16" data-id="element-282">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 text-[12px]" data-id="element-283">
        {testimonials.map((t, i) => <TestimonialCard key={i} {...t} data-id="element-284" />)}
      </div>
    </Section>;
};